
import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import StayBenefitForm from './StayBenefitForm';
import StayBenefitAdmin from './StayBenefitAdmin';
import { Tab, Tabs } from 'react-bootstrap';
import PageAccessManager from '../components/PageAccessManager';


const StayBenefitHome = ({ setMenuOptions }) => {
  const { accounts } = useMsal();

  useEffect(() => {
    setMenuOptions("Stay Benefit");
  }, []);

  if (accounts[0].idTokenClaims?.roles?.includes("PayrollAdmin")) {
    // mountOnEnter: the access list only loads when the Page Access tab is opened
    return (
      <Tabs id="stay-benefit-tabs" defaultActiveKey="submissions" className="px-4 pt-4" mountOnEnter>
        <Tab eventKey="submissions" title="Stay Benefit">
          <StayBenefitAdmin setMenuOptions={setMenuOptions} />
          <StayBenefitForm setMenuOptions={setMenuOptions} />
        </Tab>
        <Tab eventKey="access" title="Page Access">
          <PageAccessManager endpoint="staybenefit" pageName="Stay Benefit" />
        </Tab>
      </Tabs>
    );
  }
  return <StayBenefitForm setMenuOptions={setMenuOptions} />;
};

export default StayBenefitHome;